import { __assign } from "tslib";
//Imports
import * as React from 'react';
import linkifyHtml from 'linkify-html';
import { useTranslation } from 'react-i18next';
import FullCalendar from '@fullcalendar/react'; // must go before plugins
//Utils
import Popups from '../../../enums/PopupsEnum';
import { setOpacity } from '../../../utils/colorUtils';
import getAccessRoleAndCalendarName from '../../../utils/getAccessRoleAndCalendarName';
import getFCDesktopOptions from '../../../utils/getFCOptions';
import getTitleToDisplay from '../../../utils/getTitleToDisplay';
import { DEMO_CALENDARS_IDS } from '../../../constants';
//Components
import WeeklyEvent from '../../presentationals/WeeklyEvent';
import WeeklyLeftSideTime from '../../presentationals/WeeklyLeftSideTime';
import WeeklyNowIndicator from '../../presentationals/WeeklyNowIndicatorMobile';
// Context
import WeeklyContextMobile from '../../../context/weeklyContextMobile';
import WixStylesContext from '../../../context/wixStylesContext';
var WeeklyMobileCalendarFunc = function () {
    var t = useTranslation()[0];
    var _a = React.useContext(WixStylesContext), is24format = _a.is24format, isResponsive = _a.isResponsive, googleCalendarColors = _a.googleCalendarColors, isCurrentTimeShown = _a.isCurrentTimeShown;
    var _b = React.useContext(WeeklyContextMobile), privetEventsTitle = _b.privetEventsTitle, isMobile = _b.isMobile, calendarsList = _b.calendarsList, timeFormat = _b.timeFormat, onCopyClick = _b.onCopyClick, onLocationClick = _b.onLocationClick, onAttachmentClick = _b.onAttachmentClick, weekStarter = _b.weekStarter, experiments = _b.experiments, openPopup = _b.openPopup, calendarRef = _b.calendarRef, dates = _b.dates, timezone = _b.timezone, isPrivateEventsShown = _b.isPrivateEventsShown, locale = _b.locale, firstDay = _b.firstDay;
    var onEventClick = function (info) {
        var originType = info.event.extendedProps.originType;
        var _a = info.event.extendedProps, isDetailsVisible = _a.isDetailsVisible, isPrivate = _a.isPrivate, 
        // recurringEventId,
        calendarId = _a.calendarId, title = _a.title;
        var summary = info.event.extendedProps.summary;
        var accessRoleAndCalendarName = getAccessRoleAndCalendarName(calendarsList, calendarId);
        var accessRole = accessRoleAndCalendarName.accessRole;
        var calendarName = accessRoleAndCalendarName.calendarName;
        var titleToDisplay = getTitleToDisplay(t, title, privetEventsTitle, accessRole, isPrivate);
        if (DEMO_CALENDARS_IDS.includes(calendarId)) {
            titleToDisplay = t(title);
            summary = t(summary);
            calendarName = t(calendarName);
        }
        var convertToLinkifyHtml = function (summary) {
            var fixedSummary = summary.replace('</stron ', '</strong>');
            var origFixedSummary = fixedSummary;
            try {
                fixedSummary = linkifyHtml(fixedSummary, { target: '_blank' });
            }
            catch (error) {
                return origFixedSummary;
            }
            return fixedSummary || origFixedSummary;
        };
        var expandedEventsProps = {
            //From event
            title: titleToDisplay,
            calendarId: calendarId,
            copyLink: info.event.extendedProps.copyLink,
            startDate: info.event.extendedProps.startDate,
            endDate: info.event.extendedProps.endDate,
            location: info.event.extendedProps.location,
            locationLink: info.event.extendedProps.locationLink,
            summary: convertToLinkifyHtml(summary),
            recurrence: info.event.extendedProps.recurrence,
            attachments: info.event.extendedProps.attachments,
            isDetailsVisible: isDetailsVisible && !isPrivate,
            eventColor: googleCalendarColors
                ? setOpacity(1, info.event.extendedProps.googleColor)
                : setOpacity(1, info.event.extendedProps.eventColor),
            type: info.event.extendedProps.type,
            groupByStartDate: info.event.extendedProps.groupByStartDate,
            // recurringEventId,
            calendarName: calendarName,
            isWeekly: true,
            privetEventsTitle: privetEventsTitle,
            //from calendarProps
            timeFormat: timeFormat,
            onCopyClick: onCopyClick,
            onLocationClick: onLocationClick,
            onAttachmentClick: onAttachmentClick,
            weekStarter: weekStarter,
            experiments: experiments,
            originType: originType,
        };
        var expandedData = {
            // recurringEventId,
            calendarId: calendarId
        };
        if (openPopup) {
            return openPopup({
                popup: Popups.EVENT,
                expandedEventsProps: expandedEventsProps,
                expandedData: expandedData,
                isCloseFocused: true,
            });
        }
    };
    React.useEffect(function () {
        //@ts-ignore
        if (isResponsive && calendarRef.current) {
            var minHeight = 600;
            var controllersHeight = 72;
            var weekDatesHeight = 88;
            var contentHeight = minHeight - controllersHeight - weekDatesHeight;
            //@ts-ignore
            calendarRef.current.getApi().setOption('contentHeight', contentHeight);
        }
        //@ts-ignore
        if (!isResponsive && calendarRef.current) {
            //@ts-ignore
            calendarRef.current.getApi().setOption('height', 'auto');
        }
    }, [isResponsive, calendarRef]);
    return (React.createElement(React.Fragment, null,
        React.createElement(FullCalendar
        //@ts-ignore
        , __assign({ 
            //@ts-ignore
            ref: calendarRef }, getFCDesktopOptions({
            isResponsive: isResponsive,
            isCurrentTimeShown: isCurrentTimeShown,
            is24format: is24format,
            timezone: timezone,
            dates: dates,
            isPrivateEventsShown: isPrivateEventsShown,
            locale: locale,
            firstDay: firstDay,
            // recurrenceArr,
            isMobile: isMobile,
        }), { 
            //custom components
            eventContent: function (_a) {
                var event = _a.event;
                return (React.createElement(WeeklyEvent, { event: event, isMobile: true }));
            }, slotLabelContent: function (time) { return (React.createElement(WeeklyLeftSideTime, { time: time, isMobile: true, is24format: is24format, isResponsive: isResponsive })); }, nowIndicatorContent: React.createElement(WeeklyNowIndicator, null), nowIndicatorDidMount: function (el) {
                return (el.el.style.borderTopColor = 'transparent');
            }, eventClick: onEventClick }))));
};
export default WeeklyMobileCalendarFunc;
//# sourceMappingURL=WeeklyMobileCalendarFunc.js.map